import { User, AuthState, TeamMember, Error } from './types';

const mutations = {
  SET_AUTHENTICATED(state: AuthState, authenticated: boolean) {
    state.authenticated = authenticated;
  },
  SET_USER(state: AuthState, user: User) {
    state.user = user;
  },
  SET_TEAM(state: AuthState, team: TeamMember[]) {
    state.user.team = team;
  },
  SET_GROUPS(state: AuthState, groups: object[]) {
    state.user.groups = groups;
  },
  SET_TEAM_ERROR(state: AuthState, { message }: Error = { message: '' }) {
    state.errorMessage = message;
  }
};

export default mutations;
